import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC4yQtLWqNizhsmxvBgDksqIqnv00On31Y",
  authDomain: "kosher-e90e3.firebaseapp.com",
  projectId: "kosher-e90e3",
  storageBucket: "kosher-e90e3.firebasestorage.app",
  messagingSenderId: "432560127887",
  appId: "1:432560127887:web:705f1aeb2f8ce5437ed5fa"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const provider = new GoogleAuthProvider();
export const loginWithGoogle = () => signInWithPopup(auth, provider);